import React, { Component } from 'react';
import ReactDOM, { findDOMNode } from 'react-dom';
require('./index.less');
import { Modal, Button, HotKeys, Tooltip } from '@platform/base';
import { getMultiLang, getSysFieldid, getSafeRandom, microAppUtil } from '@platform/api';
const { Header, Title, Body, Footer } = Modal;
/**
 * 备注：在业务组传的确认取消回调报错的情况下，当前的PromptBox的确定和取消事件里的close不走，会导致n递增，走的回调取到的有误。
 */
let n = -1;
export class PromptBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: this.props.show || true,
            json: {},
        };
        this.uuid = props.uuid || Date.now() + getSafeRandom();
    }

    componentDidMount() {
        setTimeout(() => {
            this.buttonRef?.focus();
        }, 400);
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => {
                    //console.log('多语加载完成')
                });
            }
        };
        getMultiLang({ moduleId: 'container_toast', callback });
        if (this.props.btnClickContainer) {
            Object.assign(this.props.btnClickContainer, {
                beSureClick: this.beSureClick,
                cancelClick: this.cancelClick,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ showModal: nextProps.show || this.props.show || false });
    }

    callBackErrorHandle = (func, msg) => {
        try {
            func();
        } catch (err) {
            this.close();
            console.error(`${msg}:${err}`);
        }
    };

    /* 取消按钮事件 */
    cancelClick = () => {
        n++;
        let { bcFn } = this.props;
        if (bcFn[n] && typeof bcFn[n] === 'function') {
            // this.props.cancelBtnClick();
            // bcFn[n]();
            this.callBackErrorHandle(bcFn[n], 'PromptBox的取消回调报错');
            this.clear();
        }
        this.close();
    };

    //确认并保存按钮事件
    customBtnClick = () => {
        n++;
        let { customFn } = this.props;
        if (customFn[n] && typeof customFn[n] === 'function') {
            this.callBackErrorHandle(
                customFn[n],
                'PromptBox的确认并保存回调报错',
            );
            this.clear();
        }
        this.close();
    };

    //确认按钮事件
    beSureClick = () => {
        n++;
        let { bsFn } = this.props;
        if (bsFn[n] && typeof bsFn[n] === 'function') {
            // this.props.beSureBtnClick();
            // bsFn[n]();
            this.callBackErrorHandle(bsFn[n], 'PromptBox的确认回调报错');
            this.clear();
        }
        this.close();
    };

    //删除弹框
    close = () => {
        this.setState({ showModal: false });
    };

    onExited = () => {
        let element = this.props.getPopupContainer; //解决同时弹窗两个弹窗，关闭一个后全都关闭了的问题

        if (element) {
            ReactDOM.unmountComponentAtNode(element);
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
            // element 都不在app上，会报错的，这种内部组件，不要这样写
            // document.getElementById("app").removeChild(element);
            let $parentElement = element && element.parentElement;
            $parentElement && $parentElement.removeChild(element);
        }
    };

    closeBtnClick = () => {
        n++;
        let { bCloseFn } = this.props;
        if (bCloseFn[n] && typeof bCloseFn[n] === 'function') {
            bCloseFn[n]();
            this.clear();
        }
        this.close();
    };

    clear = () => {
        let { bsFn, bcFn, customFn, bCloseFn } = this.props;
        bsFn[n] = null;
        bcFn[n] = null;
        customFn[n] = null;
        bCloseFn[n] = null;
    };

    render() {
        let { json } = this.state;
        let {
            content,
            title = '',
            color = 'success',
            type,
            showIcon = true,
            showTitle = true,
            noFooter = false,
            noHeader = false,
            closeByClickBackDrop = false,
            noCancelBtn = false,
            showCustomBtn = false,
            customBtnPosition = 'center',
            customBtnColor = 'secondary',
            hasCloseBtn = false,
            beSureBtnName = json['0005'],
            cancelBtnName = json['0006'],
            customBtnName = json['0010'],
            customHotKey,
            // zIndex = 200,
            showModalTitle = false,
            hotKeyboard = true,
            ...other
        } = this.props;
        if (!title) {
            if (color === 'success') {
                title = json['0001'];
            } else if (color === 'info') {
                title = json['0002'];
            } else if (color === 'warning') {
                title = json['0003'];
            } else if (color === 'danger') {
                title = json['0004'];
            }
        }
        if (type === 'formula') {
            title = json["0012"];
            if (beSureBtnName === '关闭') {
                beSureBtnName = json["0008"];
            }
        }
        let toastIcon = (color, showIcon) => {
            if (!showIcon) { return null; }
            let iconName = 'icon-wancheng';
            if (color === 'danger') {
                iconName = 'icon-shibai';
            } else if (color === 'warning') {
                iconName = 'icon-zhuyi1';
            } else if (color === 'info') {
                iconName = 'icon-tixing';
            }
            let name = `iconfont ${iconName} ${color}`;
            return <span className={name} />;
        };
        let id = this.uuid;
        let indexInfo = { id };

        let customBtn = (
            <Tooltip
                placement="top"
                inverse
                overlay={customHotKey ? `${customBtnName} (${customHotKey})` : customHotKey}
                trigger={['hover']}
                className="model-helper-overlay"
            >
                <Button
                    onClick={this.customBtnClick}
                    colors={customBtnColor}
                    fieldid="customBtn"
                >
                    {customBtnName}
                    {customHotKey && customHotKey.split('+').length > 1 && (
                        <React.Fragment>
                            <span>(</span>
                            <span className="text-decoration-underline">
                                {customHotKey.split('+')[1]}
                            </span>
                            <span>)</span>
                        </React.Fragment>
                    )}
                </Button>
            </Tooltip>
        );

        let customKeyMap = customHotKey ? { customBtnHandler: customHotKey } : {};
        return (
            <Modal
                visible={this.state.showModal}
                onOk={this.beSureClick.bind(this)}
                onCancel={this.closeBtnClick.bind(this)}
                className={`prompt-box ${id}`}
                mask={closeByClickBackDrop ? true : 'static'}
                maskClosable={closeByClickBackDrop}
                indexInfo={indexInfo}
                footer={null}
                ref={Modal => (this.Modal = Modal)}
                onExited={this.onExited}
                // modalAutoFocus
                // onHide={this.onExited}
                {...other}
                fieldid={
                    this.props.fieldid ? this.props.fieldid : 'simpleConfirm'
                }
                uuid={this.uuid}
                // keyboard={hotKeyboard ? true : ['esc']}
                keyboard={['esc']}
            >
                {!noHeader && <Header closeButton={hasCloseBtn ? true : false}>
                    <Title needShowFieldId={false}>
                        {showTitle && (
                            <span
                                fieldid={getSysFieldid(`${json['0007']}_title`)}
                            >
                                {json['0007']}
                            </span>
                        )}
                        {showModalTitle ? <span fieldid={getSysFieldid(`${title}_title`)}>{title}</span> : null}
                    </Title>
                </Header>}

                <Body className={showModalTitle ? '' : 'prompt-box-body'}>
                    {showModalTitle ? null : (
                        <Title fieldid="prompt-body-title" className="prompt-box-body-title">
                            {toastIcon(color, showIcon)}
                            {<div className="title-text">{title}</div>}
                        </Title>
                    )}
                    <div
                        className="prompt-box-body-content"
                        style={showModalTitle ? { height: '100%' } : {}}
                    >
                        {content}
                    </div>
                </Body>

                {!noFooter && (
                    <Footer className={'prompt-box-footer'}>
                        {hotKeyboard && !noFooter && (
                            <HotKeys
                                keyMap={{
                                    sureBtnHandler: [
                                        HotKeys.USUAL_KEYS.MODAL_CONFIRM[0],
                                    ],
                                    cancelBtnHandler:
                                        HotKeys.USUAL_KEYS.MODAL_CANCEL,
                                    ...customKeyMap,
                                }}
                                handlers={{
                                    sureBtnHandler: () => {
                                        // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                                        if (
                                            this.Modal &&
                                            this.Modal.isTopModal()
                                        ) {
                                            console.log(
                                                'promptbox sureBtnHandler 事件回调',
                                            );
                                            this.beSureClick();
                                        }
                                    },
                                    customBtnHandler: () => {
                                        // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                                        if (
                                            this.Modal &&
                                            this.Modal.isTopModal()
                                        ) {
                                            console.log(
                                                'promptbox customBtnHandler 事件回调',
                                            );
                                            this.customBtnClick();
                                        }
                                    },
                                    cancelBtnHandler: () => {
                                        // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                                        if (
                                            this.Modal &&
                                            this.Modal.isTopModal()
                                        ) {
                                            console.log(
                                                'promptbox cancelBtnHandler 事件回调',
                                            );
                                            this.cancelClick();
                                        }
                                    },
                                }}
                                className="promptbox-hotkeys-wrapper"
                                focused={true}
                                attach={document.body}
                                display="inline"
                            />
                        )}
                        {showCustomBtn &&
                            customBtnPosition === 'left' &&
                            customBtn}
                        <Tooltip
                            placement="top"
                            inverse
                            overlay={`${beSureBtnName} (${hotKeyboard ? HotKeys.USUAL_KEYS.MODAL_CONFIRM : ''})`}
                            trigger={['hover']}
                            className="model-helper-overlay"
                        >
                            <Button
                                onClick={this.beSureClick}
                                colors="primary"
                                fieldid="confirm"
                                tabIndex="0"
                                ref={ref => {
                                    this.buttonRef = findDOMNode(ref);
                                }}
                                onBlur={() => {
                                    console.log(111111);
                                }}
                            >
                                {beSureBtnName}
                                {hotKeyboard && (
                                    <React.Fragment>
                                        <span>(</span>
                                        <span className="text-decoration-underline">
                                            Y
                                        </span>
                                        <span>)</span>
                                    </React.Fragment>
                                )}
                            </Button>
                        </Tooltip>
                        {showCustomBtn &&
                            customBtnPosition === 'center' &&
                            customBtn}
                        {!noCancelBtn && (
                            <Tooltip
                                placement="top"
                                inverse
                                overlay={`${cancelBtnName} (${hotKeyboard ? HotKeys.USUAL_KEYS.MODAL_CANCEL : ''})`}
                                trigger={['hover']}
                                className="model-helper-overlay"
                            >
                                <Button
                                    onClick={this.cancelClick}
                                    // shape="border"
                                    colors="secondary"
                                    fieldid="cancel"
                                    tabIndex="0"
                                >
                                    {cancelBtnName}
                                    {hotKeyboard && (
                                        <React.Fragment>
                                            <span>(</span>
                                            <span className="text-decoration-underline">
                                                N
                                            </span>
                                            <span>)</span>
                                        </React.Fragment>
                                    )}
                                </Button>
                            </Tooltip>
                        )}
                        {showCustomBtn &&
                            customBtnPosition === 'right' &&
                            customBtn}
                    </Footer>
                )}
            </Modal>
        );
    }
}

let beSureArr = [];
let customClickArr = [];
let cancelArr = [];
let closeArr = [];
export const promptBox = props => {
    props = props || {};
    //let app = document.getElementById('app');
    let container;
    if (props.container) {
        if (props.container.body) {
            container = props.container.body;
        } else {
            container = props.container;
        }
    } else {
        container = microAppUtil.getDocument();
    }
    let div = document.createElement('section');
    div.className = 'prompt-box-project';
    // div.style.position='absolute';
    // div.style.top='0';
    // div.style.right='0';
    beSureArr.push(props.beSureBtnClick);
    customClickArr.push(props.customBtnClick);
    cancelArr.push(props.cancelBtnClick);
    closeArr.push(props.closeBtnClick);
    // container.style.position = 'absolute';
    // container.style.top='0';
    // container.style.right='0';
    container.appendChild(div);
    const uuid = Date.now() + getSafeRandom();
    ReactDOM.render(
        <PromptBox
            {...props}
            bsFn={beSureArr}
            uuid={uuid}
            customFn={customClickArr}
            bcFn={cancelArr}
            bCloseFn={closeArr}
            getPopupContainer={div}
        />,
        div,
    );
};
